module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_5.c87ef718.png";